import o from "styled-components";
const r = o.div``, p = o(r)`
  display: flex;
  flex-direction: column;
`, e = o(r)`
  margin-top: 30px;
  margin-bottom: 16px;
`;
export {
  r as BaseWrapper,
  e as Container,
  p as Wrapper
};
